/**
 * Help Center links — Invoice app.
 *
 * Nguồn mới: https://help.invoice.fordeer.app/hc/invoice
 * (thay toàn bộ link cũ help.fordeercommerce.io).
 *
 * Article URL format mới: `/hc/invoice/articles/{id}-{slug}`.
 * Mọi chỗ cần link help trong app phải import từ file này,
 * không hardcode URL rời rạc.
 */

const HELP_CENTER_BASE = 'https://help.invoice.fordeer.app/hc/invoice'

const article = (path: string) => `${HELP_CENTER_BASE}/articles/${path}`

/** Trang chủ Help Center Invoice. */
export const HELP_CENTER_HOME = HELP_CENTER_BASE

export const HELP_LINKS = {
  home: HELP_CENTER_HOME,

  // --- Email & Automation ---
  smtpSetup: article('1789012841-how-to-set-up-smtp'),
  customEmailSender: article('1789012934-how-to-custom-email-sender'),
  documentEmailContent: article(
    '1789013144-how-to-change-document-email-content',
  ),
  attachPdfToCustomerEmails: article(
    '1789013642-how-to-attach-pdf-invoices-to-customer-emails',
  ),
  shopifyFlowAutomate: article(
    '1789013600-how-to-automate-invoices-with-shopify-flow-and-fordeer',
  ),
  automationEmailCreate: article(
    '1789013508-how-to-create-an-automation-email',
  ),
  confirmationEmailsDownloadButton: article(
    '1789014501-how-to-add-download-button-to-shopify-s-confirmation-emails',
  ),
  newCustomerAccountDownloadButton: article(
    '1789024874-how-to-add-download-button-to-new-customer-account-page',
  ),
  legacyCustomerAccountButtons: article(
    '1789024910-adding-print-and-download-buttons-to-legacy-customer-account',
  ),

  // --- Currency & Formatting ---
  currencyFormat: article('1789361359-how-to-change-the-currency-format'),
  invoiceNumbers: article('1789361463-how-to-custom-invoice-numbers'),
  refundIdFormat: article(
    '1789361492-how-to-change-the-refund-id-format-shown-on-the-invoices',
  ),

  // --- Invoice Customization ---
  customFileName: article('1788940912-how-to-custom-name-file'),

  // --- Tax & VAT ---
  vatId: article('1789352014-how-to-add-the-vat-id-to-the-invoices'),
  collectCustomerVat: article(
    '1789352075-how-to-collect-customer-s-vat-and-show-it-on-the-invoices',
  ),
  customerVatMetafields: article(
    '1789351485-how-to-display-customer-vat-i_ds-using-customer-metafields',
  ),

  // --- Getting Started ---
  defaultLanguage: article('1788929939-how-to-set-up-the-default-language'),
  adjustTranslation: article('1788929987-how-to-use-adjust-translation'),

  // --- Advanced Features ---
  createReport: article('1789371488-how-to-create-a-report'),

  // --- Billing & Account ---
  pricing: article('1789368090-fordeer-pdf-invoice-pricing'),
  subscription: article(
    '1789368131-understanding-fordeer-pdf-invoice-subscription',
  ),
  ordersPerPlan: article(
    '1789368175-how-many-orders-can-i-print-download-invoices-in-each-plan',
  ),
  cancelTrialFee: article(
    '1789368218-if-i-cancel-in-the-free-period-will-i-have-to-pay-an-amount-of-fee',
  ),
  brandingRemoval: article('1789368258-how-to-branding-removal'),

  // --- Troubleshooting ---
  partiallyPaidOrders: article(
    '1789368694-can-i-download-all-pdf-orders-which-were-partially-paid-i-want-to-know-if-it-is-possible',
  ),
  giftCards: article('1789361649-how-to-show-gift-cards-on-the-invoices'),
  getSupport: article('1789368731-how-do-i-get-support'),

  // Bài "upgrade templates 2.0" từ 2024 không còn trên help center mới
  // → trỏ về trang chủ help center.
  upgradeTemplates: HELP_CENTER_BASE,
} as const

export type HelpLinkKey = keyof typeof HELP_LINKS
